import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {CVA} from "./cva";
import {UIFormEngineComponentMetadata} from "./form";


@Component({
    selector: 'ui-input-text',
    template: `
	    <div class="ui-input-presentation" *ngIf="presentationMode">
		    {{cva.value}}
	    </div>


	    <ng-container *ngIf="!presentationMode">
	    <textarea
		ui-autoresize
		class="form-control ui-input-text"
		[(ngModel)]="cva.value"
		(ngModelChange)="writeValueFromInput($event)"
		[name]="name"
	></textarea>
	    </ng-container>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UIInputTextComponent),
            multi: true
        }
    ]
})
export class UIInputTextComponent extends CVA {
    @Input() metadata: UIFormEngineComponentMetadata;
    @Input() name;
    @Input() presentationMode = false;

}
